import { BuyerImport, CondoImport, ContractImport, DepositImport, InterimImport, PropertyImport, SellerImport } from "./DRImportFuncs"

type DRImportFieldCondition = {
    field: string,
    isOtherSide?: boolean,
    value?: string
}

export type DRImportFieldType = {
    label: string,
    src: (...args: any[]) => string,
    type?: "string" | "number" | "date" | "boolean",
    setter?: (...args: any[]) => void,
    requiredFields?: DRImportFieldCondition[],
    isBrokendown?: boolean,
}

export type DRImportSectionType = {
    isLoop: boolean,
    fields: Array<DRImportFieldType>,
    importAll?: boolean,
    setter?: (...args: any[]) => void,
    loopOn?: "Vendor" | "Purchaser" | "Deposit", // node name
    requiredFields?: DRImportFieldCondition[]
}


export const DRImportTemplate: Record<string, DRImportSectionType> = {
    "Property": {
        isLoop: false,
        importAll: true,
        fields: [
            {
                label: "Address",
                src: PropertyImport.getAddress,
                setter: PropertyImport.setAddress,
            },
            {
                label: "Assessment Roll",
                src: PropertyImport.getAssessmentRollNo,
                setter: PropertyImport.setAssessmentRollNo,
                requiredFields: [
                    {
                        field: "getAppCode",
                        value: "ON"
                    }
                ]
            },
            {
                label: "Legal Description",
                src: PropertyImport.getLegalDesc,
                setter: PropertyImport.setLegalDesc,
            },
            {
                label: "Property Type",
                src: PropertyImport.getPropertyType,
            }
        ],
    },
    "Seller" : {
        isLoop: false,
        importAll: true,
        fields: [
            {
                label: "Name",
                src: SellerImport.getSellerNameOnAgreement,
                setter: SellerImport.setSellerNameOnAgreement
            },
            {
                label: "Name on Title",
                src: SellerImport.getSellerNameOnTitle,
                setter: SellerImport.setSellerNameOnTitle
            },
            {
                label: "Gender/Corporation",
                src: SellerImport.getSellerGender,
                setter: SellerImport.setSellerGender
            },
            {
                label: "HST Number",
                type: "string",
                src: SellerImport.getSellerHSTNumber,
                setter: SellerImport.setSellerHSTNumber,
                requiredFields: [
                    {
                        field: "getAppCode",
                        value: "ON"
                    }
                ]
            },
            {
                label: "GST Number",
                type: "string",
                src: SellerImport.getSellerHSTNumber,
                setter: SellerImport.setSellerHSTNumber,
                requiredFields: [
                    {
                        field: "getAppCode",
                        value: "BC"
                    }
                ]
            },
            {
                label: "Address for Service",
                src: SellerImport.getSellerAddressForService,
                setter: SellerImport.setSellerAddressForService
            }
        ],
    },
    "Buyer": {
        isLoop: true,
        loopOn: "Purchaser",
        setter: BuyerImport.setBuyers,
        importAll: true,
        fields: [
            {
                label: "Name",
                src: BuyerImport.getBuyerNameOnAgreement,
            },
            {
                label: "Name on Title",
                src: BuyerImport.getBuyerNameOnTitle,
            },
            {
                label: "Date of Birth",
                type: "date",
                src: BuyerImport.getBuyerBirthday,
            },
            {
                label: "Gender/Corporate Status",
                src: BuyerImport.getBuyerGender,
            },
            {
                label: "Address for Service",
                src: BuyerImport.getBuyerAddressForService,
            }
        ]
    },
    "Contract": {
        isLoop: false,
        importAll: true,
        fields: [
            {
                label: "Closing Date",
                type: "date",
                src: ContractImport.getClosingDate,
                setter: ContractImport.setClosingDate,
            },
            {
                label: "Interim Closing Date", // only on interim
                type: "date",
                src: ContractImport.getInterimClosingDate,
                setter: ContractImport.setInterimClosingDate,
                requiredFields: [
                    {
                        field: "getStraightClosing",
                        value: "0",
                        isOtherSide: true
                    }
                ]
            },
            {
                label: "Contract Date",
                type: "date",
                src: ContractImport.getContractDate,
                setter: ContractImport.setContractDate,
            },
            {
                label: "Contract Price",
                type: "number",
                src: ContractImport.getContractPrice,
                setter: ContractImport.setContractPrice,
            },
            // {
            //     label: "Consideration",
            //     src: ContractImport.getConsideration,
            //     type: "number",
            //     setter: ContractImport.setConsideration,
            // },
            // {
            //     label: "Consideration for Ereg",
            //     src: ContractImport.getConsiderationEreg,
            //     type: "number",
            //     setter: ContractImport.setConsiderationEreg,
            //     requiredFields: [
            //         {
            //             field: "getAppCode",
            //             value: "ON"
            //         }
            //     ]
            // },
            {
                label: "Purchaser Entitled to HST Rebate",
                type: "boolean",
                src: ContractImport.getPurchaserEntitledHSTRebate,
                setter: ContractImport.setPurchaserEntitledHSTRebate,
                requiredFields: [
                    {
                        field: "getAppCode",
                        value: "ON"
                    }
                ]
            },
            {
                label: "Purchaser Entitled to GST Rebate",
                type: "boolean",
                src: ContractImport.getPurchaserEntitledHSTRebate,
                setter: ContractImport.setPurchaserEntitledHSTRebate,
                requiredFields: [
                    {
                        field: "getAppCode",
                        value: "BC"
                    }
                ]
            },
            {
                label: "Tarion Enrollment Date",
                type: "date",
                src: ContractImport.getTarionEnrolDate,
                setter: ContractImport.setTarionEnrolDate,
                requiredFields: [
                    {
                        field: "getAppCode",
                        value: "ON"
                    }
                ]
            },
            {
                label: "HST included in Price",
                type: "boolean",
                src: ContractImport.getIncludeHST,
                setter: ContractImport.setIncludeHST,
                requiredFields: [
                    {
                        field: "getAppCode",
                        value: "ON"
                    }
                ]
            },
            {
                label: "GST included in Price",
                type: "boolean",
                src: ContractImport.getIncludeHST,
                setter: ContractImport.setIncludeHST,
                requiredFields: [
                    {
                        field: "getAppCode",
                        value: "BC"
                    }
                ]
            },
            {
                label: "Balance Due on Closing", // condo(final)&subdivision
                type: 'number',
                src: ContractImport.getBDOC,
                setter: ContractImport.setBDOC,
            },
            // {
            //     label: "Balance Due on Occupancy Closing", // condo w/ Interim & final only
            //     type: 'number',
            //     src: ContractImport.getInterimBDOC,
            //     setter: ContractImport.setInterimBDOC,
            // },
            {
                label: "Upgrades & Extras",
                type: "number",
                src: ContractImport.getUpgrades
            }
        ],
    },
    "Deposits": {
        isLoop: true,
        loopOn: "Deposit",
        setter: DepositImport.setDeposits,
        importAll: true,
        fields: [
            {
                label: "Deposit",
                type: "number",
                src: DepositImport.getDepositAmount,
            },
        ],
    },
    "Interim Closing": {
        isLoop: false,
        fields: [
            {
                label: "Occupancy Fee",
                type: "number",
                src: InterimImport.getOccupancyFee
            },
            {
                label: "Realty Taxes",
                type: "number",
                isBrokendown: true,
                src: InterimImport.getRealtyTaxes
            },
            {
                label: "Common Expenses",
                type: "number",
                isBrokendown: true,
                src: InterimImport.getCommonExpenses
            },
            {
                label: "Interest",
                type: "string",
                isBrokendown: true,
                src: InterimImport.getInterest
            },
            {
                label: "Balance Due on Interim Closing",
                type: "number",
                src: ContractImport.getInterimBDOC,
            },
            {
                label: "Interim Closing Date",
                type: "date",
                src: ContractImport.getInterimClosingDate,
                setter: ContractImport.setInterimClosingDate
            }
        ],
        requiredFields: [
            {
                field: "getStraightClosing",
                value: "0",
                isOtherSide: true
            }
        ]
    },
    "Condominium Corporation": {
        isLoop: false,
        fields: [
            {
                label: "Name",
                type: "string",
                src: CondoImport.getCondoCorpName,
            },
            {
                label: "Number",
                type: "string",
                src: CondoImport.getCondoCorpNumber,
            },
            {
                label: "Contact Person",
                type: "string",
                src: CondoImport.getCondoCorpContactName,
            }
        ],
        requiredFields: [
            {
                field: "getPropertyType",
                value: "Condo"
            }
        ]
    }
}